export default
{
    

    REG_EXPR_VALID_PAN : /^\d{6}(\*{6,9}|\d{6,9})\d{4}$/ ,
    //REG_EXPR_VALID_PAN : /^\d{6}(\*{6}|\*{9}|\d{6}|d{9})\d{4}$/ ,
    //REG_EXPR_VALID_MASKED_PAN : /^\d{6}(\*{6}|\*{9})\d{4}$/,
    REG_EXPR_VALID_DIGITS : /^\d+$/,
    REG_EXPR_VALID_AMOUNT: /^\d{1,10}(\.\d{2,3})?$/,

    TXN_IDENTIFIER_CUSTOM : {name : "custom", label : "Identifier." },
    TXN_IDENTIFIER_PAN : {name : "pan", label : "PAN", },
    TXN_IDENTIFIER_PAYCODE : {name : "paycode", label : "Paycode"},
    TXN_IDENTIFIER_MOBILE_NO : {name : "mobileNo", label : "Mobile No." },
    


    MAX_DATE_RANGE_MONTHS  : 1, 
    DATE_FORMAT : "YYYY-MM-DD",
    DATE_FORMAT_LONG : "YYYY-MM-DD HH:mm:ss",
    DEFAULT_TABLE_PAGE_SIZE : 10,


    ROUTES_BASE_CONTEXT_PATH : "/portal/arbiter/app", //TODO Routes should not be dependent on this context path when deployed on ISW Portal 
    
    DISPUTE_CATEGORY_CHARGEBACK : "CHARGEBACK",
    DISPUTE_CATEGORY_REFUND : "REFUND",
    DISPUTE_CATEGORY_FRAUD : "FRAUD",
    DISPUTE_CATEGORY_MERCHANT_SETTLEMENT : "MERCHANT_SETTLEMENT",
    DISPUTE_CATEGORY_GOOD_FAITH : "GOOD_FAITH",

    DISPUTE_ACTION_ACCEPT : "ACCEPT",
    DISPUTE_ACTION_COMMENT : "COMMENT",
    DISPUTE_ACTION_DECLINE : "DECLINE",
    DISPUTE_ACTION_REOPEN : "REOPEN",

    DISPUTE_FIELD_EVIDENCE : "evidence",
    DISPUTE_FIELD_COMMENT : "comment",
    


    TRANSACTIONS_DISPENSE_PARTIAL : "PARTIAL_DISPENSE",
    TRANSACTIONS_NO_DISPENSE :"NO_DISPENSE",


    MAXIMUM_EVIDENCE_FILE_SIZE : 205000, //~200KB
    MAXIMUM_BATCH_FILE_SIZE : 512000, //~512KB
    MAXIMUM_EVIDENCE_UPLOAD_COUNT : 5,


    COOKIE_PREFIX_NEVER_ASK : "NEVER_ASK_",

    BATCH_STATUS_COMPLETED : "COMPLETED",

    SETTLEMENT_REQUEST_ACTION_MAP : "MAP",
    SETTLEMENT_REQUEST_ACTION_PROCESS: "PROCESS",
    SETTLEMENT_REQUEST_ACTION_CANCEL : "CANCEL",


    SETTLEMENT_REQUEST_STATUS_MAPPING : "MAPPING",
    SETTLEMENT_REQUEST_STATUS_PENDING : "PENDING"
    

};


// WEBPACK FOOTER //
// ./src/configurations/constants.js